const AppVersion = {"version": "v1.3.1"}; export default AppVersion;